import React from "react";
import MainLayout from "./MainLayout";
import NoLayout from "./NoLayout";

type LayoutType = "main" | "none";

export const LayoutManager = ({
  children,
  layoutType,
}: {
  children: React.ReactNode;
  layoutType?: LayoutType;
}) => {
  switch (layoutType) {
    case "none":
      return <NoLayout>{children}</NoLayout>;
    default:
      return <MainLayout>{children}</MainLayout>;
  }
};
